<template>
  <g>
    <path
      d="M11.97 1.5a4.26 4.26 0 110 8.53 4.26 4.26 0 010-8.53M11.97 22.37c-4.67 0-8.79-.82-8.45-2.88.9-5.39 3.7-8.53 8.45-8.53 4.75 0 7.56 3.18 8.45 8.53.34 2.06-3.77 2.88-8.45 2.88"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "UserIcon",
});
</script>
